import { MAX_LENGTH_256, MAX_LENGTH_50 } from 'Models/Constants';
import * as yup from 'yup';

export const CreateFoodOrderDestinationSchema = yup.object({
    name: yup.string().required('Errors.required').max(MAX_LENGTH_50, 'Errors.length_50'),
    email: yup.string().required('Errors.required').max(MAX_LENGTH_256, 'Errors.length_256'),
});
